import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import {toast} from "../../../../store/toaster/actions";
import {getPayslips, deletePayslip} from "../../../../store/contractors/actions";
import {connect} from "react-redux";
import { AutoSizer, Table, Column } from 'react-virtualized';
import styled from "styled-components";
import { CSVLink } from "react-csv";

import 'react-virtualized/styles.css';
import {Button, InputGroup, NonIdealState, Spinner, Dialog, Classes} from "@blueprintjs/core";
import Fuse from "fuse.js";
import Icon from "../../../../components/icon";

const StyledList = styled.div`
  height: 100%;
  width: 100%;
  padding: 8px 16px;
`;

const FUSE_OPTIONS = {
  threshold: 0.1,
  maxPatternLength: 32,
  minMatchCharLength: 2,
  keys: [
    {name: 'date', weight: 0.4},
    {name: 'gross_pay', weight: 0.2},
    {name: 'payment', weight: 0.2},
    {name: 'currency', weight: 0.2},
  ]
};

const EXCEL_HEADERS = [
  { label: 'Date', key: 'date' },
  { label: 'Gross Taxable Pay', key: 'gross_pay' },
  { label: 'Net Payment', key: 'payment' },
  { label: 'Currency', key: 'currency' },
];

class Payslips extends Component {
  state = {
    deleteDialog: false,
    dialogData: '',
    search: '',
    records: [],
    record: parseInt(this.props.match.params._id)
  }

  componentDidMount() {
    this.props.getPayslips(this.props.match.params._id, r => {});
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (this.state.record !== parseInt(nextProps.match.params._id)){
      this.setState({
        record: parseInt(nextProps.match.params._id),
      }, () => {
        this.props.getPayslips(this.props.match.params._id, r => {});
      });
    } else {
      if (nextProps.records.length){
        this.setState({
          records: this.formatData(nextProps.records),
        });
      } else {
        this.setState({
          records: [],
        });
      }
    }
  }

  handleDelete()
  {
    this.setState({deleteDialog: false});
    console.log(this.state.dialogData);
    console.log(this.props.match.params._id);
    this.props.deletePayslip(this.props.match.params._id, this.state.dialogData, () => {
      this.props.toast({message: 'Payslip was successfully deleted', intent: 'SUCCESS'});
    });
    this.setState({dialogData: ''});
  }

  handleFilter(phrase){
    let records = this.formatData(this.props.records);
    if (this.state.search.length) {
      const fuse = new Fuse(records, FUSE_OPTIONS);
      records = fuse.search(this.state.search);
    }
    this.setState({
      search: phrase,
      records
    });
  }


  formatData(records){
    let formattedRecords = [];
    records.map(record => {
      record = {
        ...record,
        gross_pay: record.gross_pay ? record.gross_pay.toFixed(2) : parseInt('0').toFixed(2),
        payment: record.payment ? record.payment.toFixed(2) : parseInt('0').toFixed(2),
        curreny: `${record.curreny}`,
        date: record.date && record.date,
      };
      return formattedRecords.push(record);
    });
    return formattedRecords;
  }

  viewFile (payslipId) {
    const { _id } = this.props.match.params;
    const url = `${process.env.REACT_APP_API_URL}/contractors/${_id}/payslips/get-file/${payslipId}?auth=${window.localStorage.getItem('ammotio-token')}&session=${window.localStorage.getItem('ammotio-session')}`;
    window.open(url, "_blank");
  }


  render() {
    const { loading } = this.props;
    const { records } = this.state;
    return (
      <React.Fragment>
        {loading ? (
          <Spinner className="mt50" />
        ) : (
          <React.Fragment>
            <div className="tools">
              <div></div>
              <div className="flex">
                {records.length > 0 &&
                  <CSVLink
                    headers={EXCEL_HEADERS}
                    data={records}
                    filename={"payslips.csv"}
                    className="mr5"
                    target="_blank"
                  >
                    <Icon icon="csv" size={38}/>
                  </CSVLink>
                }
                <InputGroup
                  leftIcon="search"
                  onChange={(e) => {
                    this.handleFilter(e.currentTarget.value)
                  }}
                  large
                  placeholder="Search"
                />
              </div>
            </div>
            {records.length ? (
              <StyledList>
              <AutoSizer>
                {({width, height}) => (
                  <Table
                    ref="Table"
                    headerHeight={30}
                    noRowsRenderer={this._noRowsRenderer}
                    overscanRowCount={10}
                    rowClassName={this._rowClassName}
                    rowHeight={30}
                    rowCount={records.length}
                    rowGetter={({ index }) => records[index]}
                    height={height}
                    width={width}>
                    <Column
                      label="Date"
                      dataKey="date"
                      width={width * 0.2}
                    />
                    <Column
                      width={width * 0.2}
                      disableSort
                      label="Gross Taxable Pay"
                      dataKey="gross_pay"
                    />
                    <Column
                      width={width * 0.2}
                      disableSort
                      label="Net Payment"
                      dataKey="payment"
                    />
                    <Column
                      width={width * 0.2}
                      disableSort
                      label="Currency"
                      dataKey="currency"
                    />
                    <Column
                      width={width * 0.2}
                      disableSort
                      style={{textAlign: 'center'}}
                      label=""
                      dataKey="id"
                      cellRenderer={({cellData}) => (<><Button style={{backgroundColor: '#fff'}} onClick={() => {this.viewFile(cellData)}} small>View</Button><Button style={{backgroundColor: 'red', color: '#fff'}} onClick={() => this.setState({deleteDialog: true, dialogData: cellData})} small>Delete</Button></>)}
                    />
                  </Table>
                )}
              </AutoSizer>
            </StyledList>
            ) : (
              <NonIdealState
                icon="search"
                title="No payslips found for this contractor"
              />
            )}
          </React.Fragment>
        )}
        <Dialog
          icon="info-sign"
          onClose={() => this.setState({deleteDialog: false})}
          title="Payslip Delete"
          isOpen={this.state.deleteDialog}>
            <div className={Classes.DIALOG_BODY}>
              <div>Are you sure?</div>
            </div>
            <div className={Classes.DIALOG_FOOTER}>
              <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                <Button onClick={() => this.setState({deleteDialog: false})}>Cancel</Button>
                <Button intent="DANGER" onClick={() => this.handleDelete()}>Delete</Button>
              </div>
            </div>
      </Dialog>
      </React.Fragment>
    );
  }
}


function matchDispatchToProps(dispatch) {
  return bindActionCreators({
    toast,
    getPayslips,
    deletePayslip
  }, dispatch);
}

function mapStateToProps(state) {
  return {
    loading: state.contractors.payslipsLoading,
    records: state.contractors.payslips,
  }
}

export default (connect(mapStateToProps, matchDispatchToProps)(Payslips));
